// RoomsSummary
import React from "react";
import { fmt2, mapToStr } from "../../../helpers/rooms.helpers";

const lightTypeLabel = (t) => {
    const x = String(t || "");
    if (x === "chandelier") return "Люстра";
    if (x === "accent") return "Акцент";
    if (x === "spots") return "Точки";
    if (x === "track") return "Трек";
    if (x === "linear") return "Линейный";
    if (x === "ledstrip") return "LED лента";
    return x || "-";
};

const mapLightsToStr = (m) => {
    const keys = Object.keys(m || {});
    if (!keys.length) return "-";
    return keys
        .sort((a, b) => lightTypeLabel(a).localeCompare(lightTypeLabel(b), "ru"))
        .map((k) => `${lightTypeLabel(k)}: ${m[k]}`)
        .join(", ");
};

export default function RoomsSummary({ totals }) {
    return (
        <div className="smeta-rooms__summary">
            <div className="smeta-rooms__summary-grid">
                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Площадь пола, м²</div>
                    <div className="smeta-rooms__v">{fmt2(totals?.floorM2)}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Потолок, м²</div>
                    <div className="smeta-rooms__v">{fmt2(totals?.ceilingM2)}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Стены (брутто), м²</div>
                    <div className="smeta-rooms__v">{fmt2(totals?.wallsGrossM2)}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Проёмы (окна+двери), м²</div>
                    <div className="smeta-rooms__v">{fmt2(totals?.openingsM2)}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Стены (нетто), м²</div>
                    <div className="smeta-rooms__v">{fmt2(totals?.wallsNetM2)}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Свет на потолке, шт</div>
                    <div className="smeta-rooms__v">{totals?.ceilingLightsQty || 0}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Дверные проемы, шт</div>
                    <div className="smeta-rooms__v">{totals?.doorsQty || 0}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Оконные проемы, шт</div>
                    <div className="smeta-rooms__v">{totals?.windowsQty || 0}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Розеток (точек), шт</div>
                    <div className="smeta-rooms__v">{totals?.socketsQty || 0}</div>
                </div>

                <div className="smeta-rooms__summary-item">
                    <div className="smeta-rooms__k">Выключателей + освещение (точек), шт</div>
                    <div className="smeta-rooms__v">{totals?.switchesQty || 0}</div>
                </div>

                <div className="smeta-rooms__summary-item smeta-rooms__summary-item--wide">
                    <div className="smeta-rooms__k">Свет по типам</div>
                    <div className="smeta-rooms__v-small">{mapLightsToStr(totals?.ceilingLightsByType)}</div>
                </div>

                <div className="smeta-rooms__summary-item smeta-rooms__summary-item--wide">
                    <div className="smeta-rooms__k">Розетки по сечению</div>
                    <div className="smeta-rooms__v-small">{mapToStr(totals?.socketsBySection)}</div>
                </div>

                <div className="smeta-rooms__summary-item smeta-rooms__summary-item--wide">
                    <div className="smeta-rooms__k">Выключатели по сечению</div>
                    <div className="smeta-rooms__v-small">{mapToStr(totals?.switchesBySection)}</div>
                </div>
            </div>
        </div>
    );
}
